import { render, staticRenderFns } from "./SimulationDetailCompareSimulations.vue?vue&type=template&id=5338a37b"
import script from "./SimulationDetailCompareSimulations.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailCompareSimulations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports